export const CELL_TO_MARKETS_DAG_NAME = 'edp_projection_cell_to_markets';

export const cellToMarketsVersionPath = (version) =>
    `gs://${process.env.REACT_APP_GCS_DATA_BASE_URL}/p_data=cell_to_markets/version=${version}`;

export const CELL_TO_MARKETS_QUERY = `query CellToMarkets($version: String) {
    cellToMarkets(version: $version) {
        universe
        region
        geographic_region: geographicRegion
        market_tag: marketTag
        nucleus_market_id: nucleusMarketId
        market
        cell_id: cellId
        cell_description: cellDescription
    }
}`;
